const inputClass =
  'mt-1 block w-full rounded-evault border border-evault-border bg-white px-3 py-2.5 text-sm text-umb-neutral-dark shadow-sm transition-colors placeholder:text-evault-muted/70 focus:border-evault-teal focus:outline-none focus:ring-2 focus:ring-evault-teal/20';

export function TextField({
  id,
  label,
  error,
  className = '',
  inputClassName = '',
  labelClassName = '',
  ...props
}) {
  return (
    <div className={className}>
      {label ? (
        <label
          htmlFor={id}
          className={
            labelClassName || 'block text-sm font-medium text-umb-neutral-dark'
          }
        >
          {label}
        </label>
      ) : null}
      <input id={id} className={`${inputClass} ${inputClassName}`.trim()} {...props} />
      {error ? (
        <p className="mt-1 text-sm text-umb-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export function SelectField({
  id,
  label,
  error,
  children,
  className = '',
  selectClassName = '',
  labelClassName = '',
  ...props
}) {
  const selectBase = inputClass;
  return (
    <div className={className}>
      {label ? (
        <label
          htmlFor={id}
          className={
            labelClassName || 'block text-sm font-medium text-umb-neutral-dark'
          }
        >
          {label}
        </label>
      ) : null}
      <select
        id={id}
        className={`${selectBase} ${selectClassName}`.trim()}
        {...props}
      >
        {children}
      </select>
      {error ? (
        <p className="mt-1 text-sm text-umb-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
